import { CheckboxProps } from "@/types/component"

import "./index.scss"

import React from "react"
import CheckboxIcon from "@/components/icons/checkbox"

export const Checkbox: React.FC<CheckboxProps> = ({ disabled, label, value, bordered = false, ...props }) => {
  return (
    <div className={`checkbox-with-text ${bordered ? "bordered" : ""}`}>
      <label className={`label ${disabled ? "disabled" : ""}`}>
        <input
          checked={value}
          className="checkbox"
          disabled={disabled}
          type="checkbox"
          {...props}
        />
        {value && (
          <span className="checkbox-icon">
            <CheckboxIcon width={16} height={16}/>
          </span>
        )}
        {label}
      </label>
    </div>
  )
}
